// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../../styles/common.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript-header_wrapper__BccH9 {
  position: relative;

  display: flex;
  flex-direction: column;

  margin: 0;
  padding: 0;
  padding: 18px 20px;
}

.transcript-header_header__EFdUv {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  margin: 0;
}
.transcript-header_headerTitle__kFYxX {
  font-size: 14px;
  font-weight: 700;
  color: var(--textColor);
}
.transcript-header_search__e5Snx {
  display: flex;
  align-items: center;

  width: 100%;
  margin: 0;
  margin-top: 18px;

  transition-timing-function: ease-in-out;
  transition-duration: 0.2s;
  transition-property: height, margin-top, opacity;
}

.transcript-header_controls__HWyKU {
  display: flex;
  gap: 8px;
  align-items: center;
}
.transcript-header_languageSelectWrapper__Z3yyH {
  position: relative;
}
.transcript-header_button__DQIjM {
}
.transcript-header_iconButton__aBX6n {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 44px;
  height: 44px;
  border-radius: 3px;

  color: var(--textColor);

  transition: background-color 0.2s ease-in-out;
}
.transcript-header_iconButton__aBX6n svg {
    color: var(--textColor);
    fill: var(--textColor);
  }
.transcript-header_iconButton__aBX6n:hover {
    background-color: var(--hoverBackground);
  }

.transcript-header_searchIcons__TangQ {
  display: flex;
  gap: 4px;
  align-items: center;
}

.transcript-header_searchPrevNext__D8Cns {
  display: flex;
  align-items: center;
}

.transcript-header_searchPrevNext__D8Cns button {
    width: 32px;
    height: 32px;
    transition: background-color 0.2s ease-in-out;
  }

.transcript-header_searchPrevNext__D8Cns button:hover {
      background-color: var(--hoverBackground);
    }
.transcript-header_searchIndicatorIcon__J9O9P {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 4px;

  color: var(--borderColor);
}
.transcript-header_clearSearch__M\\+9fJ {
  width: 32px;
  height: 32px;
  padding: 0;
}

.transcript-header_separator__Oa-SV {
  align-self: stretch;

  width: 1px;
  border-color: var(--borderColor);
  border-style: solid;
  border-width: 0 0 0 1px;
}
.transcript-header_searchResultCount__GDOvj {
  white-space: nowrap;
}
.transcript-header_chevronUp__47nr8 {
  transform: rotate(-90deg);
}
.transcript-header_chevronDown__Rm1CZ {
  transform: rotate(90deg);
}

.transcript-header_searchToggle__KmWBE {
  display: none;
}

/* Smaller screens / mobile */
.smallScreen .transcript-header_search__e5Snx.transcript-header_searchVisible__IGpNn {
      height: 44px;
      opacity: 1;
    }
.smallScreen .transcript-header_search__e5Snx:not(.transcript-header_searchVisible__IGpNn) {
      overflow: hidden;
      height: 0;
      margin-top: 0;
      opacity: 0;
    }
.smallScreen .transcript-header_searchToggle__KmWBE {
    display: flex;
  }
.smallScreen .transcript-header_searchInput__e64Hk {
    height: 40px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/transcript/transcript-header.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;;EAEtB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;;EAE9B,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;;EAEnB,WAAW;EACX,SAAS;EACT,gBAAgB;;EAEhB,uCAAuC;EACvC,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;AAEA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,uBAAuB;;EAEvB,6CAA6C;AAS/C;AARE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AAEA;IACE,wCAAwC;EAC1C;;AAGF;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AAWrB;;AATE;IACE,WAAW;IACX,YAAY;IACZ,6CAA6C;EAK/C;;AAHE;MACE,wCAAwC;IAC1C;AAGJ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;;EAEZ,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;;EAEnB,UAAU;EACV,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAGzB;MACE,YAAY;MACZ,UAAU;IACZ;AACA;MACE,gBAAgB;MAChB,SAAS;MACT,aAAa;MACb,UAAU;IACZ;AAGF;IACE,aAAa;EACf;AAEA;IACE,YAAY;EACd","sourcesContent":[".wrapper {\n  position: relative;\n\n  display: flex;\n  flex-direction: column;\n\n  margin: 0;\n  padding: 0;\n  padding: 18px 20px;\n}\n\n.header {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n  margin: 0;\n}\n.headerTitle {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--textColor);\n}\n.search {\n  display: flex;\n  align-items: center;\n\n  width: 100%;\n  margin: 0;\n  margin-top: 18px;\n\n  transition-timing-function: ease-in-out;\n  transition-duration: 0.2s;\n  transition-property: height, margin-top, opacity;\n}\n\n.controls {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.languageSelectWrapper {\n  position: relative;\n}\n.button {\n  composes: button from '../../styles/common.module.css';\n}\n.iconButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 44px;\n  height: 44px;\n  border-radius: 3px;\n\n  color: var(--textColor);\n\n  transition: background-color 0.2s ease-in-out;\n  & svg {\n    color: var(--textColor);\n    fill: var(--textColor);\n  }\n\n  &:hover {\n    background-color: var(--hoverBackground);\n  }\n}\n\n.searchIcons {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.searchPrevNext {\n  display: flex;\n  align-items: center;\n\n  & button {\n    width: 32px;\n    height: 32px;\n    transition: background-color 0.2s ease-in-out;\n\n    &:hover {\n      background-color: var(--hoverBackground);\n    }\n  }\n}\n.searchIndicatorIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 4px;\n\n  color: var(--borderColor);\n}\n.clearSearch {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n}\n\n.separator {\n  align-self: stretch;\n\n  width: 1px;\n  border-color: var(--borderColor);\n  border-style: solid;\n  border-width: 0 0 0 1px;\n}\n.searchResultCount {\n  white-space: nowrap;\n}\n.chevronUp {\n  transform: rotate(-90deg);\n}\n.chevronDown {\n  transform: rotate(90deg);\n}\n\n.searchToggle {\n  display: none;\n}\n\n/* Smaller screens / mobile */\n:global(.smallScreen) {\n  & .search {\n    &.searchVisible {\n      height: 44px;\n      opacity: 1;\n    }\n    &:not(.searchVisible) {\n      overflow: hidden;\n      height: 0;\n      margin-top: 0;\n      opacity: 0;\n    }\n  }\n\n  & .searchToggle {\n    display: flex;\n  }\n\n  & .searchInput {\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `transcript-header_wrapper__BccH9`,
	"header": `transcript-header_header__EFdUv`,
	"headerTitle": `transcript-header_headerTitle__kFYxX`,
	"search": `transcript-header_search__e5Snx`,
	"controls": `transcript-header_controls__HWyKU`,
	"languageSelectWrapper": `transcript-header_languageSelectWrapper__Z3yyH`,
	"button": `transcript-header_button__DQIjM ${___CSS_LOADER_ICSS_IMPORT_0___.locals["button"]}`,
	"iconButton": `transcript-header_iconButton__aBX6n`,
	"searchIcons": `transcript-header_searchIcons__TangQ`,
	"searchPrevNext": `transcript-header_searchPrevNext__D8Cns`,
	"searchIndicatorIcon": `transcript-header_searchIndicatorIcon__J9O9P`,
	"clearSearch": `transcript-header_clearSearch__M+9fJ`,
	"separator": `transcript-header_separator__Oa-SV`,
	"searchResultCount": `transcript-header_searchResultCount__GDOvj`,
	"chevronUp": `transcript-header_chevronUp__47nr8`,
	"chevronDown": `transcript-header_chevronDown__Rm1CZ`,
	"searchToggle": `transcript-header_searchToggle__KmWBE`,
	"searchVisible": `transcript-header_searchVisible__IGpNn`,
	"searchInput": `transcript-header_searchInput__e64Hk`
};
export default ___CSS_LOADER_EXPORT___;
